import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import Select from '../../../components/ui/Select';

const FilterPanel = ({ onApplyFilters, savedPresets = [] }) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const [filters, setFilters] = useState({
    dateRange: 'last30days',
    serviceType: 'all',
    technicianTeam: 'all',
    region: 'all'
  });

  const dateRangeOptions = [
    { value: 'today', label: "Aujourd\'hui" },
    { value: 'yesterday', label: 'Hier' },
    { value: 'last7days', label: '7 derniers jours' },
    { value: 'last30days', label: '30 derniers jours' },
    { value: 'thisMonth', label: 'Ce mois' },
    { value: 'lastMonth', label: 'Mois dernier' },
    { value: 'custom', label: 'Période personnalisée' }
  ];

  const serviceTypeOptions = [
    { value: 'all', label: 'Tous les services' },
    { value: 'plumbing', label: 'Plomberie générale' },
    { value: 'heating', label: 'Chauffage' },
    { value: 'emergency', label: 'Urgences' },
    { value: 'maintenance', label: 'Maintenance' }
  ];

  const teamOptions = [
    { value: 'all', label: 'Toutes les équipes' },
    { value: 'team-a', label: 'Équipe A - Paris Nord' },
    { value: 'team-b', label: 'Équipe B - Paris Sud' },
    { value: 'team-c', label: 'Équipe C - Banlieue Est' },
    { value: 'team-d', label: 'Équipe D - Banlieue Ouest' }
  ];

  const regionOptions = [
    { value: 'all', label: 'Toutes les régions' },
    { value: 'paris', label: 'Paris' },
    { value: 'idf', label: 'Île-de-France' },
    { value: 'north', label: 'Nord' },
    { value: 'south', label: 'Sud' }
  ];

  const handleApply = () => {
    onApplyFilters(filters);
    setIsExpanded(false);
  };

  const handleReset = () => {
    const resetFilters = {
      dateRange: 'last30days',
      serviceType: 'all',
      technicianTeam: 'all',
      region: 'all'
    };
    setFilters(resetFilters);
    onApplyFilters(resetFilters);
  };

  const handlePresetLoad = (preset) => {
    setFilters(preset?.filters);
    onApplyFilters(preset?.filters);
    setIsExpanded(false);
  };

  return (
    <div className="bg-card rounded-lg border border-border card-elevated-1 overflow-hidden">
      <div 
        className="p-4 flex items-center justify-between cursor-pointer hover:bg-muted/30 transition-colors"
        onClick={() => setIsExpanded(!isExpanded)}
      >
        <div className="flex items-center gap-3">
          <Icon name="Filter" size={20} className="text-primary" />
          <h3 className="font-semibold text-foreground">Filtres avancés</h3>
        </div>
        <Icon 
          name={isExpanded ? "ChevronUp" : "ChevronDown"} 
          size={20} 
          className="text-muted-foreground"
        />
      </div>
      {isExpanded && (
        <div className="p-6 border-t border-border space-y-6 animate-slide-up">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
            <Select
              label="Période"
              options={dateRangeOptions}
              value={filters?.dateRange}
              onChange={(value) => setFilters({ ...filters, dateRange: value })}
            />

            <Select
              label="Type de service"
              options={serviceTypeOptions}
              value={filters?.serviceType}
              onChange={(value) => setFilters({ ...filters, serviceType: value })}
            />

            <Select
              label="Équipe"
              options={teamOptions}
              value={filters?.technicianTeam}
              onChange={(value) => setFilters({ ...filters, technicianTeam: value })}
            />

            <Select
              label="Région"
              options={regionOptions}
              value={filters?.region}
              onChange={(value) => setFilters({ ...filters, region: value })}
            />
          </div>

          {savedPresets?.length > 0 && (
            <div>
              <p className="text-sm font-medium text-muted-foreground mb-3">Préréglages sauvegardés</p>
              <div className="flex flex-wrap gap-2">
                {savedPresets?.map((preset) => (
                  <button
                    key={preset?.id}
                    onClick={() => handlePresetLoad(preset)}
                    className="px-3 py-1.5 rounded-lg border border-border hover:bg-muted transition-colors text-sm font-medium text-foreground"
                  >
                    <Icon name="Bookmark" size={14} className="inline mr-2" />
                    {preset?.name}
                  </button>
                ))}
              </div>
            </div>
          )}

          <div className="flex items-center gap-3 pt-4 border-t border-border">
            <Button variant="default" onClick={handleApply} iconName="Check">
              Appliquer les filtres
            </Button>
            <Button variant="outline" onClick={handleReset} iconName="RotateCcw">
              Réinitialiser
            </Button>
            <Button variant="ghost" iconName="Save" className="ml-auto">
              Sauvegarder comme préréglage
            </Button>
          </div>
        </div>
      )}
    </div>
  );
};

export default FilterPanel;